export default {
  isLoading: false,
  isLoadingCreatePaymentRequest: false,
  accounts: [],
  paymentMethods: [],
  selectedAccount: null,
  selectedPaymentMethod: null,
  serverError: null,
};
